import {Splide} from "@splidejs/splide";

// hero sider
const sliderHero = document.getElementById("heroSlider");
if (sliderHero) {
    new Splide(sliderHero,
        {
            type   : 'loop',
            arrows: true,
            perPage: 1,
            pagination:false,     
            autoplay: true,
            interval: 3500, 
            speed: 2000,
        }
    ).mount({   }); 
}

// Reviews sider
const sliderReviews = document.getElementById("reviewsSlider");
if (sliderReviews) {
    new Splide(sliderReviews,
        {
            type   : 'loop',
            arrows: false,
            pagination:true,
            perPage: 1,
            autoplay: true,
            interval: 3500, 
            speed: 2000,
        }
    ).mount({   }); 
}

